// extracted by mini-css-extract-plugin
export default {"metaInfo":"StyleAssetThumb_metaInfo__0SE8K","open":"StyleAssetThumb_open__YovkY"};